module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp12_7.07447b6e.png";